<app-main-page [navItems]="navigationItems"></app-main-page>

<app-distribute-fleets></app-distribute-fleets>
